export const getCurrencySymbol = (currency: string) => {
  switch (currency.toLowerCase()) {
    case 'usd':
      return '$'
    case 'eur':
      return '$'
  }
}
